// extracted by mini-css-extract-plugin
module.exports = {"header":"Heading_header__GGoOR"};